import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart, Scatter } from 'recharts';

export const AreaAndScatterChart = (props) => {
    return (
        <>
            {props.data ?
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        width={200}
                        height={100}
                        data={props.data}
                        margin={{
                            top: 10,
                            right: 40,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" fontSize={8} angle="320" interval={0} tickMargin={10} height={30} />
                        <YAxis domain={[35, 'dataMax + 5']} type="number"  allowDataOverflow={true} tickCount={8} fontSize={10} interval={0}/>
                        <Tooltip />
                        <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#4473ca" name={props.name}/>
                        <Scatter dataKey="cnt" name={props.nameScatter}/>
                    </ComposedChart>
                </ResponsiveContainer>
                : <div style={{height: '100%', display: 'flex', alignItems: 'center'}}>No Data</div>}
        </>
    )
}